export const formatCurrency = (amount, currency) => {
  const currencyFormats = {
    EUR: { locale: 'it-IT', currency: 'EUR' },
    USD: { locale: 'en-US', currency: 'USD' },
    GBP: { locale: 'en-GB', currency: 'GBP' }
  };

  const format = currencyFormats[currency] || currencyFormats.EUR;

  return new Intl.NumberFormat(format.locale, {
    style: 'currency',
    currency: format.currency
  }).format(amount || 0);
}; 